const zh_CN = {

  'start' : '开始',
  'complete' : '去完成',
  'completed' : '已完成',
  'check' : '查看',
  'buy' : '购买',
  'balance' : '余额',
  'next' : '下一步',
  'exchange_rate' : '汇率',
  'exchange' : '兑换',
  'volume' : '量',
  'latest_exchange' : '最新兑换',
  'annualized_income' : '年化收益',
  'total_balance' : '总资产',
  'close' : '收起',
  'price' : '参考报价',
  'no_data' : '暂无数据',
  'flash_exchange' : '闪电兑换',
  'tips' : '提示',

}
export default zh_CN
